import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BauortEntry, GwrgemeindeService } from '../../../core/gwr-api';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { AbstractTypeaheadSearch } from '../../components/typeahead-search/abstract-typeahead-search';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';

@Component({
  selector: 'cap-bauort',
  templateUrl: './bauort.component.html',
  styleUrls: ['./bauort.component.scss'],
  host: {
    class: 'form-control-component'
  },
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BauortComponent), multi: true }],
  imports: [FormsModule, NgbTypeahead, MetaDisablerDirective, MetaValidatorDirective]
})
export class BauortComponent
  extends AbstractTypeaheadSearch<BauortEntry>
  implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy
{
  @Input()
  hasfocus = false;

  public isOpen = false;
  model;
  value = '';

  propagateChange: (bauort: BauortEntry) => void;
  propagateTouch: (_) => void;

  private reset = false;
  private gemeindeSubscription: Subscription;

  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  static sortByName(a: BauortEntry, b: BauortEntry) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  constructor(private gwrgemeindeService: GwrgemeindeService) {
    super();
  }

  ngOnInit() {
    const findAll = this.gwrgemeindeService
      .getBauorteAll()
      .pipe(map((response: Array<BauortEntry>) => response.sort(BauortComponent.sortByName)));
    this.setSearch(findAll);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.hasfocus) {
        this.searchInput.nativeElement.focus();
      }
    });
  }

  writeValue(entry: BauortEntry): void {
    if (entry?.name && entry?.nummer) {
      this.value = entry.name + ' ' + entry.nummer;
      this.model = entry;
      this.propagateChange(entry);
      this.reset = false;
    } else if (!this.reset) {
      this.reset = true;
      this.value = '';
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  formatEntry(entry: BauortEntry): string {
    if (entry?.name && entry?.nummer) {
      return entry.name + ' ' + entry.nummer;
    }
    return '';
  }

  onSelected($event: NgbTypeaheadSelectItemEvent<BauortEntry>) {
    const selectedItem: BauortEntry = $event.item;
    if (selectedItem) {
      this.value = this.formatEntry(selectedItem);
      this.propagateChange(selectedItem);
      this.reset = false;
    } else {
      this.model = null;
      this.value = '';
      this.propagateChange(null);
    }
  }

  onClear() {
    super.onClear();
    this.model = null;
  }

  ngOnDestroy(): void {
    this.gemeindeSubscription?.unsubscribe();
  }
}
